module.exports = __webpack_public_path__ + "static/media/5BIANCA_Official_MENU-20522.c2f457ef.jpg";